import { render, staticRenderFns } from "./ProductOptionsPopupIframe.vue?vue&type=template&id=5178023a&"
import script from "./ProductOptionsPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductOptionsPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports